export default function ContainerPreview({ getInputType, item, css, ukey }) {
	return (
		<div
			className="d-flex"
			style={{
				gap: css?.gap || "0.5rem",
				justifyContent: css?.justifyContent || "flex-start",
				flexDirection: "column",

				...css,
			}}
		>
			{item.map((i) => (
				<div
					key={i.key}
					style={{
						flex: "1",
						...i.css,
					}}
				>
					{getInputType(i)}
				</div>
			))}
		</div>
	);
}
